import { useState } from 'react';

const ToggleLength = ({ text = '', limit = 30 }) => {
    const [isFullLength, setIsFullLength] = useState(false);

    if (!text) return null;

    const shouldTruncate = text.length > limit;
    const displayText = shouldTruncate && !isFullLength ? `${text.substring(0, limit)}…` : text;

    return (
        <div className="toggle-text">
            {displayText}
            {shouldTruncate && (
                <button
                    className="toggle-text__btn"
                    type="button"
                    onClick={() => setIsFullLength(prev => !prev)}
                >
                    {isFullLength ? 'Visa mindre' : 'Visa alla'}
                </button>
            )}
        </div>
    );
};

export default ToggleLength;

